import React from 'react';

import {
  Box,
  Button,
  styled,
  Typography
} from '@mui/material';
import { beginSubscriptionDataService } from 'modules';



const SectionBox = styled(Box)({
  display: 'flex',
  flexDirection:'row',
  alignItems: 'center'
});



export const BeginSubscriptionSection: React.FC = () => {
  const {
    data,
    queryLoading,
    queryRefetch,
    endTrialEarlyMutateLoading,
    fnEndTrialEarlyMutate
  } = beginSubscriptionDataService.useBeginSubscriptionQuery();



  if (queryLoading || !data || data.status !== 'trialing') {
    return <></>;
  }

  return (
    <SectionBox px={2}>
      <Typography>
        You have {data.dayLeft} days left in your free trial.&emsp;
      </Typography>

      <Button
        onClick={async () => {
          await fnEndTrialEarlyMutate();
          await queryRefetch();
        }}
        disabled={queryLoading || endTrialEarlyMutateLoading}>
        Begin Annual Subscription
      </Button>

      <Typography>
        &nbsp; to access more Ridge materials now.
      </Typography>
    </SectionBox>
  );
};
